export default "__VITE_ASSET__Dvk0ABbY__"